<h1>Groups</h1>
<span *ngxPermissionsOnly="['can_create_group']"><paper-fab  mat-raised-button icon="add" color="accent" class="action" routerLink="/groups/new-group">
</paper-fab>
</span>
<div id="content">
<mat-grid-list [cols]="breakpoint" rowHeight="120" (window:resize)="onResize($event.target)">
    <mat-grid-tile *ngFor="let group of groups">
            <mat-card appearance="outlined" class="mat-elevation-z3 group-card" (click)="navigateToGroup(group._id)">
                <mat-card-header>
<!--                    <div mat-card-avatar><i class="material-icons tangy-foreground-secondary group-avatar">supervisor_account</i>-->
<!--                    </div>-->
                    <div mat-card-avatar class="material-icons tangy-foreground-secondary group-avatar">supervisor_account</div>
                    <mat-card-title>
                        {{group.label}}
                    </mat-card-title>
                    <mat-card-subtitle>Created: {{moment(group.created).format('YYYY-MM-DD hh:mm a')}}</mat-card-subtitle>
                </mat-card-header>
            </mat-card>
    </mat-grid-tile>
</mat-grid-list>
</div>
